import { IPublicClientApplication } from '@azure/msal-browser';
import { getAccessToken } from '../app-stores';
import { scopes } from '../models/scopes';

export const withApiAccessToken = async <T>(
  instance: IPublicClientApplication,
  apiCallPromise: (accessToken?: string) => Promise<T>,
): Promise<T> => {
  const accessToken = await getAccessToken(
    instance,
    [
      scopes.accessAsUser
    ],
  );

  return apiCallPromise(accessToken);
};
